import React from 'react';
import { classNames } from '@/lib/format';

export const PageHeader = ({ title, subtitle, actions, breadcrumbs, className }) => {
  return (
    <div className={classNames('flex flex-col gap-3 md:flex-row md:items-end md:justify-between', className)} data-testid="page-header">
      <div>
        {breadcrumbs && (
          <div className="mb-2 flex items-center gap-1.5 text-xs text-muted-foreground">{breadcrumbs}</div>
        )}
        <h1 className="text-2xl font-semibold tracking-tight md:text-3xl" data-testid="page-header-title">{title}</h1>
        {subtitle && <p className="mt-1.5 text-sm text-muted-foreground max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
};
